import { DateTime } from 'luxon'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'

export const formatThreadTime = (
  iso: string,
  now: DateTime = DateTime.now()
): string => {
  const at = DateTime.fromISO(iso)
  const minutes = Math.floor(now.diff(at, 'minutes').minutes)
  if (minutes < 1) return 'now'
  if (minutes < 60) return `${minutes}m`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h`
  return at.hasSame(now, 'year')
    ? at.toFormat(DATE_FORMATS_LUXON.MONTH_DAY)
    : at.toFormat(DATE_FORMATS_LUXON.DISPLAY_SHORT)
}
